import api from './apiClient';

export interface ImportJobStatus {
  jobId: string;
  status: 'extracting' | 'converting' | 'uploading' | 'generating_scripts' | 'creating_project' | 'creating_scenes' | 'completed' | 'failed';
  progress: number;
  totalSlides: number;
  processedSlides: number;
  projectId: number | null;
  error: string | null;
}

export interface ImportOptions {
  importSpeakerNotes?: boolean;
  generateAIScripts?: boolean;
}

export async function importPptx(
  file: File,
  projectName?: string,
  aspectRatio?: string,
  options?: ImportOptions
): Promise<{ jobId: string }> {
  const formData = new FormData();
  formData.append('file', file);
  if (projectName) formData.append('projectName', projectName);
  if (aspectRatio) formData.append('aspectRatio', aspectRatio);
  if (options?.importSpeakerNotes !== undefined) formData.append('importSpeakerNotes', String(options.importSpeakerNotes));
  if (options?.generateAIScripts !== undefined) formData.append('generateAIScripts', String(options.generateAIScripts));

  const response = await api.post('/api/presentations/import-pptx', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000,
  });

  return response.data;
}

export async function importGoogleSlides(
  url: string,
  projectName?: string,
  aspectRatio?: string,
  options?: ImportOptions
): Promise<{ jobId: string }> {
  const response = await api.post('/api/presentations/import-google-slides', {
    url,
    projectName,
    aspectRatio,
    importSpeakerNotes: options?.importSpeakerNotes,
    generateAIScripts: options?.generateAIScripts,
  });

  return response.data;
}

export async function getImportStatus(jobId: string): Promise<ImportJobStatus> {
  const response = await api.get(`/api/presentations/import-status/${jobId}`);
  return response.data;
}

export function getStatusMessage(status: ImportJobStatus['status']): string {
  switch (status) {
    case 'extracting': return 'Extracting slides and notes...';
    case 'converting': return 'Converting slides to images...';
    case 'uploading': return 'Uploading slide images...';
    case 'generating_scripts': return 'Generating scripts with AI...';
    case 'creating_project': return 'Setting up your project...';
    case 'creating_scenes': return 'Creating scenes...';
    case 'completed': return 'Import complete!';
    case 'failed': return 'Import failed';
    default: return 'Processing...';
  }
}
